import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../Navbar";
import Dropdown from "./Dropdown";

export default function BondFunds({ user }) {
    const navigate = useNavigate();

    const goNext = () => {
        navigate("/MarketAndTargetFunds");
    };

    const goPrev = () => {
        navigate("/StockFunds");
    };

    return (
        <div className="h-screen overflow-hidden">
            <Navbar user={user} />
            <Dropdown />
            <div className="w-full flex flex-col justify-center items-center overflow-hidden">
                <div className="text-[#000000] text-5xl m-4 font-bold">
                    Bond Funds
                </div>
                <span className="w-full h-0.5 bg-blueInFigma"></span>
                <div className="text-[#000000] text-3xl mt-3">
                    Bond funds invest in fixed income, or bonds and debt.  The fund’s portfolio 
                </div>
                <div className="text-[#000000] text-3xl">
                    generates interest, which is then passed on to the shareholders.  They generally 
                </div>
                <div className="text-[#000000] text-3xl">
                    buy undervalued bonds and sell them at profit and will generally pay higher 
                </div>
                <div className="text-[#000000] text-3xl">
                    returns, but they are relatively high risk since they are also susceptible to interest 
                </div>
                <div className="text-[#000000] text-3xl">
                    rate risks along with the normal risks.
                </div>
            </div>
            <button className="bg-[#73C4FC] text-[#FFFFFF] p-4 absolute bottom-[10%] right-[17.5%] text-3xl rounded-2xl"
                onClick={goNext}
            >
                Next
            </button>
            <button className="bg-blueInFigma text-[#FFFFFF] p-4 absolute bottom-[10%] left-[17.5%] text-3xl rounded-2xl"
                onClick={goPrev}
            >
                Prev
            </button>
        </div>
    );
}